/**
 * KAN-826: page "Организации" (/companies): organizations of the clients with
 * a search by name, ИНН or city and server pagination. Data and state live in
 * useClientCompaniesPage.
 */
import { useEffect } from 'react';
import { Loader2, Search } from 'lucide-react';
import { PageLayout } from '@/components/layout/PageLayout';
import { PaginationBar } from '@/components/common/PaginationBar';
import { Input } from '@/components/ui/input';
import { ClientCompaniesTable } from '@/components/clientCompanies/ClientCompaniesTable';
import { useClientCompaniesPage } from '@/hooks/useClientCompanies';

export function ClientCompaniesPage() {
  const { search, setSearch, paging, list } = useClientCompaniesPage();
  const data = list.data;

  useEffect(() => {
    document.title = 'Организации - SMETA AI';
  }, []);

  let content;
  if (list.isLoading) {
    content = (
      <div className="flex justify-center py-12">
        <Loader2 className="h-6 w-6 animate-spin text-gray-400" aria-label="Загрузка" />
      </div>
    );
  } else if (list.isError) {
    content = <p className="py-8 text-center text-sm text-red-700">Не удалось загрузить организации</p>;
  } else if (!data || data.results.length === 0) {
    content = (
      <p data-testid="client-companies-empty" className="py-12 text-center text-sm text-gray-500">
        Организаций нет
      </p>
    );
  } else {
    content = (
      <>
        <ClientCompaniesTable rows={data.results} />
        <PaginationBar
          page={paging.page}
          pageSize={paging.pageSize}
          count={data.count}
          onPageChange={paging.setPage}
          onPageSizeChange={paging.setPageSize}
        />
      </>
    );
  }

  return (
    <PageLayout title="Организации" breadcrumbs={[{ label: 'Организации' }]} data-testid="client-companies-page">
      <div className="min-w-0 space-y-3">
        <div className="relative max-w-md">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
          <Input
            type="search"
            aria-label="Поиск организаций"
            placeholder="Название, ИНН или город"
            className="pl-9"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        {content}
      </div>
    </PageLayout>
  );
}
